import { BtnPrimary, BtnSecondary } from '../ui/components';
import { t } from '../i18n';
import { currentPlayers } from '../screens/GameSetup';
import { sanitizeHtml } from '../utils/sanitize';
import { state } from '../store';
import { reportRoundResult } from './TournamentEngine';
import { shuffle } from '../utils/random';
import { cardsManager } from './cardsManager';

let currentWords: string[] = [];
let currentIndex: number = 0;
let currentPlayerIndex: number = 0;
let currentGameTitle: string = '';
let currentEmojiInput: string = '';
export let _emojiWordRevealed: boolean = false;
let emojiRevealTimeout: number | null = null;
let trnCountdownInterval: number | null = null;
let trnSecondsLeft: number = 0;
let _useCardsManager = false;

declare global {
  interface Window {
    trnEmojiJudgement: (success: boolean) => void;
  }
}

function isTournamentPlay(): boolean {
  return !!state.tournament && state.tournament.status === 'playing';
}

function startTrnCountdown(seconds: number): void {
  stopTrnCountdown();
  trnSecondsLeft = seconds;
  const update = () => {
    const el = document.getElementById('trn-timer-num');
    if (el) el.textContent = String(trnSecondsLeft);
    if (trnSecondsLeft <= 0) {
      stopTrnCountdown();
      window.trnEmojiJudgement(false);
    } else {
      trnSecondsLeft--;
    }
  };
  update();
  trnCountdownInterval = window.setInterval(update, 1000);
}

function stopTrnCountdown(): void {
  if (trnCountdownInterval) { clearInterval(trnCountdownInterval); trnCountdownInterval = null; }
}

window.trnEmojiJudgement = (success: boolean) => {
  stopTrnCountdown();
  reportRoundResult(success);
  const tr = state.tournament;
  if (tr && tr.status === 'finished') {
    window.navTo('tournament-victory');
  } else {
    window.navTo('tournament-board');
  }
};

const EMOJI_PICK_LIST = [
  // 😀 Лица и эмоции
  '😀','😂','🤣','😅','😊','😍','🥰','😘',
  '😎','🤩','🥳','😏','😒','😢','😭','😱',
  '🤯','😤','🤬','🥺','🤢','🤮','😴','🤔',
  '🤫','🤥','😇','🥶','🥵','😈','👻','💀',
  // 👋 Жесты и люди
  '👍','👎','👏','🙌','🤝','✌️','🤞','👆',
  '👇','👈','👉','💪','🦵','🦶','👀','👁️',
  '👶','👦','👧','👨','👩','👴','👵','🧑‍🍳',
  '👮','💂','🕵️','👷','🤴','👸','🧙','🧛',
  // 🐶 Животные
  '🐶','🐱','🐭','🐹','🐰','🦊','🐻','🐼',
  '🐨','🐯','🦁','🐮','🐷','🐸','🐵','🐔',
  '🐧','🐦','🦅','🦆','🦉','🐴','🦄','🐝',
  '🐛','🦋','🐌','🐍','🐢','🐙','🦀','🐠',
  '🦈','🐋','🐊','🦕','🦖','🐘','🦏','🦒',
  // 🌸 Природа
  '🌸','🌺','🌻','🌹','🌳','🌴','🍀','🌈',
  '☀️','🌙','⭐','⚡','🔥','❄️','💧','🌊',
  '🌍','🌋','🏔️','🏖️','🌅','🌌',
  // 🍕 Еда и напитки
  '🍕','🍔','🍟','🌭','🍿','🧀','🥚','🍳',
  '🥞','🍞','🍩','🍪','🎂','🍰','🍫','🍬',
  '🍎','🍌','🍇','🍉','🍓','🥑','🌽','🥕',
  '🍺','🍷','🍸','☕','🧃','🥤',
  // ⚽ Спорт и активности
  '⚽','🏀','🏈','⚾','🎾','🏐','🎱','🏓',
  '🏊','🚴','🏋️','⛷️','🏄','🧗','🎯','🎳',
  // 🚗 Транспорт
  '🚗','🚕','🚌','🚑','🚒','🚀','✈️','🚢',
  '🚲','🏍️','🚂','🚁','⛵','🛸',
  // 🏠 Здания и места
  '🏠','🏰','🏗️','🏥','🏫','⛪','🕌','🗽',
  '🗼','🎡','🎢','🎪',
  // 🎵 Музыка и развлечения
  '🎵','🎶','🎤','🎸','🥁','🎹','🎬','📸',
  '🎮','🕹️','🎲','🧩','🎭','🎨','🎪','🏆',
  '👑','🥇','🥈','🥉','🎁','🎉','🎊','🎈',
  // 💡 Предметы
  '💡','🔑','🔒','📱','💻','📺','📷','⏰',
  '💰','💎','💣','🔫','🪄','🧲','🪞','🧸',
  '📚','✏️','📌','✂️','🩹','💊','🧪','🔬',
  // ❤️ Символы
  '❤️','🧡','💛','💚','💙','💜','🖤','🤍',
  '💔','❣️','💕','💫','✨','💥','💢','💤',
  '🚫','⛔','✅','❌','❓','❗','♻️','🔴',
  '🟢','🔵','⬛','⬜',
  // 🌍 Флаги (популярные страны)
  '🇷🇺','🇺🇸','🇬🇧','🇩🇪','🇫🇷','🇮🇹','🇯🇵','🇨🇳',
  '🇧🇷','🇪🇸','🇰🇷','🇮🇳','🇨🇦','🇦🇺','🇲🇽','🇳🇱',
  '🇸🇪','🇳🇴','🇵🇱','🇹🇷',
  // 🏃 Активности и спорт (недостающие)
  '🧘','🤸','🏌️','🤺','🤼','🤾','🏇','🧜',
  '🪂','🛹','🛼','🏒','🏑','🏏','🪃','🥊',
  '🥋','🎿','⛸️',
  // 🌮 Еда (недостающая)
  '🌮','🌯','🥙','🧆','🥘','🍜','🍝','🍛',
  '🍲','🥗','🧇','🥓','🥩','🦞','🦐','🦑',
  '🍡','🧁','🥧','🫕','🫔','🫙','🧋','🍵',
  '🫖','🥂','🍾','🧊',
  // 🏡 Места и путешествия
  '🗺️','🧭','⛺','🏕️','🏜️','🏝️','🌁','🌃',
  '🏙️','🌉','🎠','🏟️','🏛️','🕍','⛩️','💒',
  // 🚀 Транспорт (недостающий)
  '🛻','🚐','🚎','🏎️','🚓','🚔','🚖','🛺',
  '🚜','🛵','🛤️','🛣️','⛽','🚧','🛳️','🚤',
  '⛴️','🛥️','🚠','🚡',
  // 💼 Работа и офис
  '💼','🗂️','📊','📈','📉','🖨️','⌨️','🖱️',
  '💾','📀','🖥️','📡','🔭','⚗️','🧫','🧬',
  '💉','🩺','🩻',
  // 🎭 Развлечения (недостающие)
  '🎰','🎟️','🃏','🀄','🎴','🪀','🪁','🎻',
  '🪕','🎷','🎺','🪘','🎙️','📻','🎚️',
  // 👗 Одежда и аксессуары
  '👒','🎩','🧢','⛑️','💍','👟','👠','👡',
  '👢','🥾','🧤','🧣','🧦','👙','🩱','🩲',
  '🩳','👔','🥻',
  // 🌿 Природа (недостающая)
  '🌾','🍄','🪸','🪨','🪵','🌿','🍃','🍂',
  '🍁','🌱','🌵','🎄','🌲','🎋','🎍','🪴',
  '🌼','🐚','🪷','💐',
  // 🧠 Разное полезное
  '🔮','🗿','🪬','🧿','🗝️','🔐','🏹','⚔️',
  '🛡️','🪤','💡','🔦','🕯️','🪔','🧨','🎆',
  '🎇','🌟','🌠','☄️','🌪️',
];

declare global {
  interface Window {
    startEmojiGame: (title: string, words: string[]) => void;
    addEmojiToInput: (emoji: string) => void;
    clearEmojiInput: () => void;
    emojiGuessed: () => void;
    revealEmojiWord: () => void;
    __tapFeedback?: () => void;
  }
}

window.startEmojiGame = async (title: string, words: string[]) => {
  currentGameTitle = title;
  currentIndex = 0;
  currentPlayerIndex = 0;
  currentEmojiInput = '';
  _emojiWordRevealed = false;

  if (words && words.length > 0) {
    // Tournament mode — use provided words directly
    _useCardsManager = false;
    currentWords = shuffle([...words]);
  } else {
    // cardsManager mode
    _useCardsManager = true;
    const card = await cardsManager.getNext();
    if (!card) {
      (window as any).showToast?.(t('cards_finished'), 'info');
      window.navTo('games');
      return;
    }
    currentWords = [card.text];
  }

  window.navTo('emoji-game');
};

window.addEmojiToInput = (emoji: string) => {
  if (!EMOJI_PICK_LIST.includes(emoji)) return;
  if ([...currentEmojiInput].length >= 16) return;
  currentEmojiInput += emoji;
  const display = document.getElementById('emoji-display');
  if (display) {
    display.textContent = currentEmojiInput;
  }
  const counter = document.getElementById('emoji-counter');
  if (counter) {
    counter.textContent = `${[...currentEmojiInput].length} / 16`;
  }
};

window.clearEmojiInput = () => {
  currentEmojiInput = '';
  const display = document.getElementById('emoji-display');
  if (display) {
    display.textContent = '';
  }
  const counter = document.getElementById('emoji-counter');
  if (counter) {
    counter.textContent = `0 / 16`;
  }
};

window.revealEmojiWord = () => {
  _emojiWordRevealed = true;
  const el = document.getElementById('emoji-word-reveal');
  if (el) { el.style.filter = 'blur(0px)'; el.style.userSelect = 'text'; }
  if (emojiRevealTimeout) clearTimeout(emojiRevealTimeout);
  emojiRevealTimeout = window.setTimeout(() => {
    _emojiWordRevealed = false;
    const el2 = document.getElementById('emoji-word-reveal');
    if (el2) { el2.style.filter = 'blur(12px)'; el2.style.userSelect = 'none'; }
  }, 3000);
};

window.emojiGuessed = async () => {
  _emojiWordRevealed = false;
  if (emojiRevealTimeout) { clearTimeout(emojiRevealTimeout); emojiRevealTimeout = null; }

  if (_useCardsManager) {
    const next = await cardsManager.getNext();
    if (next) {
      currentWords = [next.text];
      currentIndex = 0;
    } else {
      (window as any).showToast?.(t('cards_finished'), 'info');
      window.navTo('games');
      return;
    }
  } else {
    currentIndex = (currentIndex + 1) % currentWords.length;
  }

  currentPlayerIndex = (currentPlayerIndex + 1) % currentPlayers.length;
  currentEmojiInput = '';
  window.renderApp();
};

/** Attach delegated click listener for emoji grid (call after rendering) */
export function setupEmojiGridListener(): void {
  const grid = document.getElementById('emoji-grid');
  if (!grid) return;
  grid.addEventListener('click', (e) => {
    const el = (e.target as HTMLElement).closest<HTMLElement>('[data-emoji]');
    if (!el) return;
    try { window.__tapFeedback && window.__tapFeedback(); } catch (_) { /* ignore */ }
    const emoji = el.dataset.emoji;
    if (emoji) window.addEmojiToInput(emoji);
  });
}

export function cleanupEmojiGame(): void {
  stopTrnCountdown();
  if (emojiRevealTimeout) { clearTimeout(emojiRevealTimeout); emojiRevealTimeout = null; }
  _emojiWordRevealed = false;
  currentEmojiInput = '';
  currentIndex = 0;
  currentPlayerIndex = 0;
  if (_useCardsManager) cardsManager.cleanup();
  _useCardsManager = false;
}

export function renderEmojiGameEngine(): string {

  const isTrn = isTournamentPlay();
  const trnTeam = isTrn ? state.tournament!.teams[state.tournament!.currentTeamIndex] : null;
  const trnPlayer = isTrn
    ? (() => {
        const team = trnTeam!;
        const cursor = state.tournament!.currentPlayerInTeam[team.id] ?? 0;
        const pid = team.playerIds[cursor % team.playerIds.length];
        const p = currentPlayers.find(pp => pp.id === pid);
        return p ? { emoji: p.emoji, name: p.name } : null;
      })()
    : null;
  const headerTitle = isTrn ? `🏆 ${trnTeam!.emoji} ${sanitizeHtml(trnTeam!.name)}` : sanitizeHtml(currentGameTitle);
  const currentPlayer = isTrn
    ? (trnPlayer || { emoji: trnTeam!.emoji, name: trnTeam!.name })
    : currentPlayers[currentPlayerIndex % currentPlayers.length];
  const turnLabel = isTrn ? t('trn_play_player_label') : t('game_turn_label');
  const currentWord = currentWords[currentIndex];
  
  const emojiButtonsHtml = EMOJI_PICK_LIST.map(em => `
    <div
      class="text-[28px] p-[2px] cursor-pointer rounded-[8px] bg-white/5 flex items-center justify-center aspect-square transition-transform duration-150 border border-transparent active:scale-[1.3] active:border-neon-pink"
      data-emoji="${em}"
    >
      ${em}
    </div>
  `).join('');

  return `
    <style>
      @keyframes fadeIn { from { opacity: 0; transform: scale(0.9); } to { opacity: 1; transform: scale(1); } }
    </style>
    <div class="absolute inset-0 overflow-hidden bg-void z-20 pb-0 flex flex-col pt-[16px]" id="screen-emoji-game">
      
      <!-- Header -->
      <div class="flex flex-col items-center w-full shrink-0 relative z-10 pt-[0px] pb-[0px]">
        <div class="flex flex-col items-center w-full px-[20px] relative py-[0px]">
          <div class="w-[38px] h-[38px] absolute left-[20px] top-[0px] bg-white/5 border border-white/10 rounded-full flex items-center justify-center cursor-pointer text-[18px] transition-all duration-150 active:scale-[0.92] active:bg-white/10 z-20" ${isTrn ? 'data-action="trn-exit-confirm"' : 'data-action="nav" data-to="games"'}>←</div>
          <div class="font-display text-[20px] font-extrabold text-white text-center leading-[38px] w-full px-[40px] z-10">${headerTitle}</div>
        </div>
        <div class="mt-[8px] bg-[rgba(255,255,255,0.06)] backdrop-blur-md border border-white/10 rounded-pill px-[16px] py-[6px] text-[14px] font-extrabold text-white flex items-center justify-center gap-[6px] shadow-[0_0_12px_rgba(255,255,255,0.05)] text-center w-max mx-auto relative z-10 animate-[fadeIn_0.3s_ease-out]" data-player-idx="${currentPlayerIndex}">
          <span class="text-[12px] tracking-[0.5px] uppercase text-t-secondary mr-[2px]">${turnLabel}</span> <span class="text-[18px] leading-none">${currentPlayer.emoji}</span> <span>${sanitizeHtml(currentPlayer.name)}</span>
        </div>
      </div>
      
      <div class="flex flex-col flex-1 min-h-0">
        <div class="flex-1 flex flex-col overflow-y-auto overflow-x-hidden scrollbar-none min-h-0">
          <div class="text-center p-[16px_20px_0]">
            <div class="text-[13px] font-bold text-t-secondary">${t('emoji_instruction')}</div>
            <div class="text-[13px] text-t-muted mt-[2px] font-semibold">${t('emoji_others')}</div>
          </div>

          <div class="m-[16px] p-[16px_20px] bg-[linear-gradient(135deg,rgba(255,23,68,0.12),rgba(160,32,240,0.06))] border border-[#ff1744]/25 rounded-xl text-center">
            <div class="text-[12px] font-extrabold tracking-[1.5px] text-[#ff1744]/80 mb-[10px]">${t('emoji_express')}</div>
            <div
              id="emoji-word-reveal"
              data-action="reveal-emoji-word"
              style="filter: blur(12px); user-select: none; cursor: pointer; transition: filter 0.3s ease;"
              class="font-display text-[22px] font-extrabold text-white uppercase select-none leading-tight"
            >${currentWord}</div>
            <div class="text-[12px] text-t-muted mt-[8px] font-semibold">${t('emoji_tap_hint')}</div>
          </div>

          <!-- Emoji input display -->
          <div class="m-[0_16px] px-[12px] py-[12px] bg-white/5 border-[2px] border-dashed border-white/20 rounded-xl text-center text-[28px] tracking-[4px] min-h-[64px] flex items-center justify-center break-all leading-tight flex-wrap content-center" id="emoji-display">
            ${currentEmojiInput}
          </div>
          <div id="emoji-counter" class="text-right text-[11px] font-bold text-t-muted mt-[4px] px-[16px]">${[...currentEmojiInput].length} / 16</div>

          <!-- Quick emoji grid -->
          <div class="px-[16px] pb-[2px] mt-auto">
            <div class="text-[11px] font-extrabold text-t-muted tracking-[1px] mb-[6px]">${t('emoji_tap_label')}</div>
            <div
              style="height: 220px; overflow-y: auto; overflow-x: hidden;"
              class="scrollbar-none"
            >
              <div id="emoji-grid" class="grid grid-cols-8 gap-[6px] pb-[4px]">
                ${emojiButtonsHtml}
              </div>
            </div>
          </div>
        </div>

        <!-- Actions -->
        ${(() => {
          if (isTournamentPlay()) {
            const trn = state.tournament!;
            const dur = trn.settings.turnDurationSec;
            if (dur > 0 && trnCountdownInterval === null) {
              setTimeout(() => startTrnCountdown(dur), 50);
            }
            const timerHtml = dur > 0 ? `
              <div class="text-center mb-[8px]">
                <span class="text-[11px] font-extrabold tracking-[1.5px] text-t-muted">${t('trn_play_timer_label')}: </span>
                <span id="trn-timer-num" class="font-display text-[24px] font-extrabold text-neon-pink">${dur}</span>
                <span class="text-[12px] text-t-muted">s</span>
              </div>
            ` : '';
            return `
              <div class="p-[8px_16px] pb-[max(16px,env(safe-area-inset-bottom))] flex flex-col shrink-0">
                ${timerHtml}
                <div class="flex gap-[10px]">
                  <button class="flex-1 py-[14px] px-[20px] bg-glass border border-neon-red/40 rounded-pill text-white font-body text-[14px] font-extrabold active:scale-[0.97]" data-action="trn-emoji-judgement" data-result="false">
                    ${t('trn_play_failed')}
                  </button>
                  <button class="flex-1 py-[14px] px-[20px] bg-grad-green rounded-pill text-white font-body text-[14px] font-extrabold shadow-glow-green active:scale-[0.97]" data-action="trn-emoji-judgement" data-result="true">
                    ${t('trn_play_guessed')}
                  </button>
                </div>
              </div>
            `;
          }
          return `
            <div class="p-[8px_16px] pb-[max(16px,env(safe-area-inset-bottom))] flex gap-[10px] shrink-0">
              <div class="flex-1">${BtnSecondary({ text: t('emoji_clear'), onClick: 'clear-emoji-input' })}</div>
              <div class="flex-1">${BtnPrimary({ text: t('emoji_guessed'), onClick: 'emoji-guessed' })}</div>
            </div>
          `;
        })()}
      </div>
    </div>
  `;
}
